import { create } from 'zustand';

export type WorkspaceBlockedCode = 'WORKSPACE_BLOCKED' | 'WORKSPACE_EXPIRED';

interface WorkspaceBlockedState {
  isOpen: boolean;
  code: WorkspaceBlockedCode | null;
  workspaceId: string | null;
  workspaceName: string | null;
  show: (params: { code: WorkspaceBlockedCode; workspaceId: string; workspaceName?: string }) => void;
  close: () => void;
}

export const useWorkspaceBlockedStore = create<WorkspaceBlockedState>((set) => ({
  isOpen: false,
  code: null,
  workspaceId: null,
  workspaceName: null,
  show: ({ code, workspaceId, workspaceName }) =>
    set({ isOpen: true, code, workspaceId, workspaceName: workspaceName ?? null }),
  close: () =>
    set({ isOpen: false, code: null, workspaceId: null, workspaceName: null }),
}));
